import React from 'react';
import { JQLValidationMessage } from './jql-validation-message';
import { JQLEditorHelp } from './jql-editor-help';
export var JQLEditorFooterContent = function JQLEditorFooterContent() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(JQLValidationMessage, null), /*#__PURE__*/React.createElement(JQLEditorHelp, null));
};